import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const NovoChamado = Loadable({
  loader: () => import('../views/Servicedesk/NovoChamado'),
  loading: RouteLoading,
});

const ConsultaChamado = Loadable({
  loader: () => import('../views/Servicedesk/ConsultaChamado'),
  loading: RouteLoading,
});

const DetalhesChamado = Loadable({
  loader: () => import('../views/Servicedesk/DetalhesChamado'),
  loading: RouteLoading,
});

const EditarChamado = Loadable({
  loader: () => import('../views/Servicedesk/EditarChamado'),
  loading: RouteLoading,
});

const Dashboard = Loadable({
  loader: () => import('../views/Servicedesk/Dashboard'),
  loading: RouteLoading,
});

const RouteServicedesk = [
  {
    path: '/servicedesk/novo-chamado',
    exact: true,
    name: 'Novo Chamado',
    component: NovoChamado
  },
  {
    path: '/servicedesk/consulta-chamado/details/:IdChamado',
    exact: true,
    name: 'Detalhes do Chamado',
    component: DetalhesChamado
  },
  {
    path: '/servicedesk/consulta-chamado/dashboard/:dashparams',
    exact: true,
    name: 'Consulta de Chamados',
    component: ConsultaChamado
  },
  {
    path: '/servicedesk/consulta-chamado',
    exact: true,
    name: 'Consulta de Chamados',
    component: ConsultaChamado
  },
  {
    path: '/servicedesk/consulta-chamado/edit/:IdChamado',
    exact: true,
    name: 'Editar Chamado',
    component: EditarChamado
  },
  {
    path: '/servicedesk/dashboard',
    exact: true,
    name: 'Dashboard',
    component: Dashboard
  },
]

export { RouteServicedesk };
